import { Spinner } from 'react-bootstrap';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { Colors } from '../../../../../themes/colors';
import { TabViewContainer } from '../../../../commonComponents/TabViewContainer';
import { Table } from '../../../../commonComponents/Table/Table';
import { CustomSelect } from '../../../UsersList/components/CustomSelect';
import {
  InterviewStatus,
  interviewStatusOptions,
  useOnsiteInterviews,
} from './hooks/useOnsiteInterviews';
import {
  onsiteInterviewColumns,
  onsiteInterviewConditionalRowStyles,
} from './onsite-interviews-columns';

const ROWS_PER_PAGE = 15;

export const OnsiteInterviewScreen = () => {
  const match = useRouteMatch();
  const history = useHistory();
  const { jobId } = match.params;

  const {
    data,
    totalFiltered,
    totalPages,
    filter,
    isLoading,
    handleStatusChange,
    handlePageChange,
    handleSort,
  } = useOnsiteInterviews(jobId);

  const handleRowClick = (row) => {
    history.push(`/job/${row.id}`);
  };

  const handleCreateClick = () => {
    history.push(`/permanent-job/job/${jobId}/create-onsite-interview`);
  };

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
        <Spinner
          animation="border"
          role="status"
          variant="info"
          style={{
            height: 30,
            width: 30,
            marginLeft: 20,
            marginTop: 10,
          }}
        />
      </div>
    );
  }

  return (
    <TabViewContainer
      title="Onsite Interviews"
      variant="card"
      style={{
        width: '95%',
        maxWidth: 1360,
        paddingBottom: 36,
      }}
      TitleTrailing={
        <div
          style={{ flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}
        >
          <button
            type="button"
            onClick={handleCreateClick}
            style={{
              backgroundColor: Colors.secondary_500,
              color: Colors.white,
              border: 'none',
              borderRadius: 4,
              padding: '8px 16px',
              fontSize: 14,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Create Onsite Interview
          </button>
        </div>
      }
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
          marginBottom: 20,
        }}
      >
        <CustomSelect
          id="interviewStatus"
          label="Interview Status"
          value={filter.status}
          onChange={(_, value) => handleStatusChange(value || InterviewStatus.ALL)}
          options={interviewStatusOptions}
        />

        <span
          style={{
            fontSize: 20,
            fontWeight: 'bold',
            color: Colors.neutral_600,
          }}
        >
          Total | {totalFiltered}
        </span>
      </div>

      <Table
        keyField="id"
        initialPage={filter.page}
        columns={onsiteInterviewColumns()}
        data={data}
        noDataComponent={<div style={{ paddingTop: 32 }}>There are no onsite interviews</div>}
        isLoading={isLoading}
        totalPages={totalPages}
        showTotal={false}
        showColumnsToHide={false}
        onSort={handleSort}
        paginationPerPage={ROWS_PER_PAGE}
        paginationTotalRows={totalFiltered}
        onPageChange={handlePageChange}
        onRowClicked={handleRowClick}
        conditionalRowStyles={onsiteInterviewConditionalRowStyles}
        paginationStyle={{ marginBottom: 0 }}
      />
    </TabViewContainer>
  );
};
